import { useEffect, useRef } from 'react';
import { useAuth } from '../context/UnifiedAuthContext';
import { usePushNotifications } from '../hooks/usePushNotifications';

/**
 * Invisible component that sets up push notifications.
 * Must be rendered inside AuthProvider and Router context.
 *
 * Handles:
 * - Registering device token when user logs in
 * - Unregistering token when user logs out
 */
export default function PushNotificationSetup() {
  const { user } = useAuth();
  const { unregisterToken } = usePushNotifications(user);
  const prevUser = useRef(user);

  // Detect logout (user goes from truthy to null)
  useEffect(() => {
    if (prevUser.current && !user) {
      unregisterToken();
    }
    prevUser.current = user;
  }, [user, unregisterToken]);

  return null;
}
